import React, { useState, useEffect } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';

const Leaderboard = ({ onClose, selectedCategory }) => {
  const [topBeans, setTopBeans] = useState([]);
  const db = getDatabase();

  useEffect(() => {
    const beansRef = ref(db, 'beans');
    const unsubscribe = onValue(beansRef, (snapshot) => {
      const data = snapshot.val();
      let allBeans = [];
      if (data) {
        for (let id in data) {
          allBeans.push({ id, ...data[id] });
        }
      }

      const filteredBeans = selectedCategory
        ? allBeans.filter(bean => bean.category === selectedCategory)
        : allBeans;

      // Sort beans by likes in descending order
      const sortedBeans = filteredBeans.sort((a, b) => b.likes - a.likes);
      setTopBeans(sortedBeans);
    });

    return () => unsubscribe();
  }, [db, selectedCategory]);

  return (
    <div className="leaderboard-container">
      <div className="leaderboard-header">
        <button onClick={onClose} className="back-button">← Back</button>
        <h2>Top Beanz {selectedCategory ? `(${selectedCategory})` : ''}</h2>
      </div>
      <div className="bean-list">
        {topBeans.map((bean) => (
          <div key={bean.id} className="bean-item">
            <img src={bean.image} alt={bean.title} />
            <div className="bean-info">
              <h3>{bean.title}</h3>
              <p>Likes: {bean.likes}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leaderboard;